import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'

export type SubscriptionCore = {
    subscriptionId?: string
    accountId: string
    scope: string
    storeId: string
    source: string
    partnerId: string
    chargebeeSubscriptionId: string
    status: string
    primaryFlag: boolean
    startAt: string
    currentPeriodStart: string
    currentPeriodEnd: string
    renewalAt: string
    trialEndAt: string
    cancelAt: string
    canceledAt: string
}

export type SubscriptionItemInput = {
    planId: string
    quantity: number
    isBasePlan: boolean
    metered: boolean
}

export type CreateSubscriptionInput = {
    accountId: string
    scope: string
    storeId: string | null
    source: string
    partnerId: string | null
    chargebeeSubscriptionId: string | null
    status: string
    primaryFlag: boolean
    startAt: string | null
    currentPeriodStart: string | null
    currentPeriodEnd: string | null
    renewalAt: string | null
    trialEndAt: string | null
    cancelAt: string | null
    canceledAt: string | null
    items: SubscriptionItemInput[]
}

export const createSubscription = (data: CreateSubscriptionInput): Promise<any> => {
    return api.post('/v2/subscriptions', data)
}

type UseCreateSubscriptionOptions = {
    mutationConfig?: MutationConfig<typeof createSubscription>
}

export const useCreateSubscription = ({ mutationConfig }: UseCreateSubscriptionOptions = {}) => {
    const queryClient = useQueryClient()
    const { onSuccess, ...restConfig } = mutationConfig || {}

    return useMutation({
        mutationFn: createSubscription,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions'] })
            onSuccess?.(...args)
        },
        ...restConfig,
    })
}